"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentsDeliverablesService = void 0;
class DeploymentsDeliverablesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Execute action for a deployment
     * @param deploymentId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    executeDeliverableAction(deploymentId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{deploymentId}/deliverables/{id}/actions',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Execute action for a deployment with result
     * @param deploymentId
     * @param id
     * @param requestBody
     * @returns DeliverableExecuteActionResponse
     * @throws ApiError
     */
    executeDeliverableActionWithResult(deploymentId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{deploymentId}/deliverables/{id}/actionsWithResult',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update deployment configuration
     * @param deploymentId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateDeliverableConfiguration(deploymentId, id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{deploymentId}/deliverables/{id}/config',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Approve negotiation
     * @param deploymentId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    approveDeliverableNegotiation(deploymentId, id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{deploymentId}/deliverables/{id}/approveNegotiation',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
        });
    }
    /**
     * Reject negotiation
     * @param deploymentId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    rejectDeliverableNegotiation(deploymentId, id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{deploymentId}/deliverables/{id}/rejectNegotiation',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
        });
    }
    /**
     * Update deliverable progress manually
     * @param deploymentId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateDeliverableProgressManually(deploymentId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{deploymentId}/deliverables/{id}/goalProgress',
            path: {
                'deploymentId': deploymentId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get file signed url
     * @param requestBody
     * @returns GetFileSignedUrlResponse
     * @throws ApiError
     */
    generateFileSignedUrl(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/files',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Fix deliverable prerequisites group 9
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsDeliverablesControllerFixDeliverablePrerequisitesGroup9(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/bugfix/amounts',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Queue TikTok deployment deliverables for tracking
     * @returns any Successful response
     * @throws ApiError
     */
    queueTikTokDeploymentDeliverableTracking() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/queue-tiktok-tracking',
        });
    }
}
exports.DeploymentsDeliverablesService = DeploymentsDeliverablesService;
